import React from 'react';
import { SvgContainer } from '../components/styled';

export type UnionIcon = {};

export function UnionIcon({}: UnionIcon) {
  return (
    <SvgContainer>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 19 18"
        width="24"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 10C11.7614 10 14 7.76142 14 5C14 2.23858 11.7614 0 9 0C6.23858 0 4 2.23858 4 5C4 6.44777 4.61532 7.75182 5.59871 8.6649C2.31433 10.0065 0 13.233 0 17C0 17.5523 0.447715 18 1 18H9C9.55229 18 10 17.5523 10 17C10 16.4477 9.55229 16 9 16H2.07089C2.55612 12.6077 5.47353 10 9 10ZM12 5C12 6.65685 10.6569 8 9 8C7.34315 8 6 6.65685 6 5C6 3.34315 7.34315 2 9 2C10.6569 2 12 3.34315 12 5Z"
          fill="#42526E"
        />
        <path
          d="M14 11C14 10.4477 14.4477 10 15 10C15.5523 10 16 10.4477 16 11V13H18C18.5523 13 19 13.4477 19 14C19 14.5523 18.5523 15 18 15H16V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V15H12C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13H14V11Z"
          fill="#42526E"
        />
      </svg>
    </SvgContainer>
  );
}
